/* Medicube Theme JS */
(function() {
  'use strict';

  /* --- Announcement Bar Rotation --- */
  function initAnnouncementBar() {
    const bar = document.querySelector('[data-announcement-bar]');
    if (!bar) return;
    const slides = bar.querySelectorAll('.announcement-bar__slide');
    if (slides.length < 2) return;
    const prevBtn = bar.querySelector('[data-announcement-prev]');
    const nextBtn = bar.querySelector('[data-announcement-next]');
    let current = 0;
    let interval;

    function goTo(index) {
      slides[current].classList.remove('is-active');
      current = (index + slides.length) % slides.length;
      slides[current].classList.add('is-active');
    }

    function startAuto() {
      interval = setInterval(function() { goTo(current + 1); }, 4000);
    }
    function stopAuto() { clearInterval(interval); }

    if (prevBtn) prevBtn.addEventListener('click', function() { stopAuto(); goTo(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { stopAuto(); goTo(current + 1); startAuto(); });

    startAuto();
  }

  /* --- Sticky Header --- */
  function initStickyHeader() {
    var header = document.querySelector('.site-header');
    if (!header) return;

    var headerSection = header.closest('.shopify-section');
    if (!headerSection) return;

    var placeholder = headerSection.querySelector('.header-placeholder');
    if (!placeholder) {
      placeholder = document.createElement('div');
      placeholder.className = 'header-placeholder';
      header.after(placeholder);
    }
    placeholder.classList.remove('is-active');
    placeholder.style.height = '0px';

    var isFixed = false;
    var ticking = false;

    function getTriggerOffset() {
      var announcementBar = document.querySelector('.announcement-bar');
      if (announcementBar) return announcementBar.offsetHeight;
      var prevSection = headerSection.previousElementSibling;
      if (prevSection) return prevSection.offsetHeight;
      return 0;
    }

    function update() {
      var scrollY = window.scrollY;
      var triggerOffset = getTriggerOffset();

      if (triggerOffset > 0 && scrollY > triggerOffset) {
        if (!isFixed) {
          placeholder.style.height = header.offsetHeight + 'px';
          placeholder.classList.add('is-active');
          header.classList.add('is-fixed');
          isFixed = true;
        }
      } else {
        if (isFixed) {
          header.classList.remove('is-fixed');
          placeholder.classList.remove('is-active');
          placeholder.style.height = '0px';
          isFixed = false;
        }
      }
      ticking = false;
    }

    function onScroll() {
      if (!ticking) {
        requestAnimationFrame(update);
        ticking = true;
      }
    }

    function onResize() {
      if (isFixed) {
        header.classList.remove('is-fixed');
        placeholder.classList.remove('is-active');
        placeholder.style.height = '0px';
        isFixed = false;
      }
      update();
    }

    window.addEventListener('scroll', onScroll, { passive: true });
    window.addEventListener('resize', onResize);
    update();
  }

  /* --- Mobile Menu --- */
  function initMobileMenu() {
    const openBtn = document.querySelector('[data-mobile-menu-open]');
    const menu = document.querySelector('[data-mobile-menu]');
    const overlay = document.querySelector('[data-mobile-menu-overlay]');
    const closeBtn = document.querySelector('[data-mobile-menu-close]');
    if (!openBtn || !menu) return;

    function openMenu() {
      menu.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function closeMenu() {
      menu.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    openBtn.addEventListener('click', openMenu);
    if (closeBtn) closeBtn.addEventListener('click', closeMenu);
    if (overlay) overlay.addEventListener('click', closeMenu);

    // Accordion toggles for submenu
    menu.querySelectorAll('.mobile-menu__toggle').forEach(function(btn) {
      btn.addEventListener('click', function() {
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', String(!expanded));
        var submenu = btn.nextElementSibling;
        if (submenu) submenu.hidden = expanded;
      });
    });
  }

  /* --- Hero Slider (handled by initHeroSliderV2 below) --- */
  function initHeroSlider() {}

  /* --- Product Carousel Scroll (handled by initAllCarousels below) --- */
  function initCarousels() {}

  /* --- Cart Drawer --- */
  function initCartDrawer() {
    const cartBtn = document.querySelector('[data-cart-toggle]');
    const drawer = document.querySelector('.cart-drawer');
    const overlay = document.querySelector('.cart-drawer__overlay');
    const closeBtn = document.querySelector('.cart-drawer__close');
    if (!drawer) return;

    function openCart() {
      drawer.classList.add('is-open');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }
    function closeCart() {
      drawer.classList.remove('is-open');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    if (cartBtn) cartBtn.addEventListener('click', function(e) { e.preventDefault(); openCart(); });
    if (closeBtn) closeBtn.addEventListener('click', closeCart);
    if (overlay) overlay.addEventListener('click', closeCart);
  }

  /* --- Product Page: Variant Selector --- */
  function initProductForm() {
    const form = document.querySelector('.product-form');
    if (!form) return;

    const select = form.querySelector('.product-form__variant-select');
    const priceEl = document.querySelector('.product-page__price-current');
    const comparePriceEl = document.querySelector('.product-page__price-compare');
    const addBtn = form.querySelector('.product-form__add-btn');

    if (select) {
      select.addEventListener('change', function() {
        var option = select.options[select.selectedIndex];
        if (option && priceEl) {
          priceEl.textContent = option.dataset.price || priceEl.textContent;
        }
        if (option && comparePriceEl) {
          comparePriceEl.textContent = option.dataset.comparePrice || '';
        }
      });
    }

    // Quantity buttons
    var qtyMinus = form.querySelector('[data-qty-minus]');
    var qtyPlus = form.querySelector('[data-qty-plus]');
    var qtyInput = form.querySelector('.product-form__quantity-input');
    if (qtyMinus && qtyPlus && qtyInput) {
      qtyMinus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        if (val > 1) qtyInput.value = val - 1;
      });
      qtyPlus.addEventListener('click', function() {
        var val = parseInt(qtyInput.value) || 1;
        qtyInput.value = val + 1;
      });
    }
  }

  /* --- Init All --- */
  document.addEventListener('DOMContentLoaded', function() {
    initAnnouncementBar();
    initStickyHeader();
    initMobileMenu();
    initSearchOverlay();
    initHeroSlider();
    initCarousels();
    initCartDrawer();
    initProductForm();
    initCollectionPage();
  });

  /* --- Search Overlay & Predictive Search --- */
  function initSearchOverlay() {
    var overlay = document.querySelector('[data-search-overlay]');
    var openBtns = document.querySelectorAll('[data-search-open]');
    var closeBtn = overlay ? overlay.querySelector('[data-search-close]') : null;
    var input = overlay ? overlay.querySelector('[data-search-input]') : null;
    var resultsContainer = overlay ? overlay.querySelector('[data-search-products]') : null;
    var emptyState = overlay ? overlay.querySelector('[data-search-empty]') : null;
    var loadingState = overlay ? overlay.querySelector('[data-search-loading]') : null;
    if (!overlay || !input) return;

    var debounceTimer;

    function openSearch() {
      overlay.classList.add('is-open');
      overlay.setAttribute('aria-hidden', 'false');
      document.body.style.overflow = 'hidden';
      setTimeout(function() { input.focus(); }, 100);
    }

    function closeSearch() {
      overlay.classList.remove('is-open');
      overlay.setAttribute('aria-hidden', 'true');
      document.body.style.overflow = '';
      input.value = '';
      if (resultsContainer) { resultsContainer.hidden = true; resultsContainer.innerHTML = ''; }
      if (emptyState) emptyState.hidden = false;
    }

    openBtns.forEach(function(btn) { btn.addEventListener('click', openSearch); });
    if (closeBtn) closeBtn.addEventListener('click', closeSearch);

    overlay.addEventListener('click', function(e) {
      if (e.target === overlay) closeSearch();
    });

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && overlay.classList.contains('is-open')) closeSearch();
    });

    input.addEventListener('input', function() {
      var query = input.value.trim();
      clearTimeout(debounceTimer);
      if (query.length < 2) {
        if (resultsContainer) { resultsContainer.hidden = true; resultsContainer.innerHTML = ''; }
        if (emptyState) emptyState.hidden = false;
        if (loadingState) loadingState.hidden = true;
        return;
      }
      if (emptyState) emptyState.hidden = true;
      if (loadingState) loadingState.hidden = false;

      debounceTimer = setTimeout(function() {
        fetchPredictiveSearch(query);
      }, 300);
    });

    function fetchPredictiveSearch(query) {
      var url = '/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=8';
      fetch(url)
        .then(function(r) { return r.json(); })
        .then(function(data) {
          if (loadingState) loadingState.hidden = true;
          var products = data.resources && data.resources.results && data.resources.results.products;
          if (products && products.length > 0) {
            renderResults(products);
          } else {
            if (resultsContainer) { resultsContainer.hidden = true; resultsContainer.innerHTML = ''; }
            if (emptyState) { emptyState.hidden = false; emptyState.innerHTML = '<p>No results for "' + query + '"</p>'; }
          }
        })
        .catch(function() {
          if (loadingState) loadingState.hidden = true;
        });
    }

    function renderResults(products) {
      if (!resultsContainer) return;
      var html = '';
      products.forEach(function(product) {
        var img = product.image || '';
        var price = product.price ? ('$' + (parseFloat(product.price) / 1).toFixed(2)) : '';
        html += '<a href="' + product.url + '" class="search-overlay__product-item">';
        if (img) html += '<img src="' + img + '" alt="' + (product.title || '') + '" width="140" height="140" loading="lazy">';
        html += '<div class="search-overlay__product-title">' + (product.title || '') + '</div>';
        html += '<div class="search-overlay__product-price">' + price + '</div>';
        html += '</a>';
      });
      resultsContainer.innerHTML = html;
      resultsContainer.hidden = false;
      if (emptyState) emptyState.hidden = true;
    }
  }

  /* --- Collection Page --- */
  function initCollectionPage() {
    var filterToggle = document.querySelector('[data-filter-toggle]');
    var sidebar = document.querySelector('[data-filters-sidebar]');
    if (!filterToggle || !sidebar) return;

    filterToggle.addEventListener('click', function() {
      sidebar.classList.toggle('is-open');
      if (sidebar.classList.contains('is-open')) {
        var overlay = document.createElement('div');
        overlay.className = 'collection-filter-overlay';
        overlay.style.cssText = 'position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,0.5);z-index:999;';
        overlay.addEventListener('click', function() {
          sidebar.classList.remove('is-open');
          overlay.remove();
        });
        document.body.appendChild(overlay);
      } else {
        var existing = document.querySelector('.collection-filter-overlay');
        if (existing) existing.remove();
      }
    });

    // Filter accordion toggles
    document.querySelectorAll('[data-filter-heading]').forEach(function(heading) {
      heading.addEventListener('click', function() {
        var expanded = this.getAttribute('aria-expanded') === 'true';
        this.setAttribute('aria-expanded', String(!expanded));
        var body = this.nextElementSibling;
        if (body) {
          body.hidden = expanded;
        }
      });
    });

    // Sort select
    var sortSelect = document.querySelector('[data-sort-select]');
    if (sortSelect) {
      sortSelect.addEventListener('change', function() {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', this.value);
        window.location.href = url.toString();
      });
    }

    // Variant select in product cards
    document.querySelectorAll('[data-variant-select]').forEach(function(select) {
      select.addEventListener('change', function() {
        var card = this.closest('[data-product-card]');
        if (!card) return;
        var hiddenInput = card.querySelector('[data-variant-id]');
        if (hiddenInput) {
          hiddenInput.value = this.value;
        }
      });
    });

    // Add to cart AJAX
    document.querySelectorAll('[data-add-to-cart-form]').forEach(function(form) {
      form.addEventListener('submit', function(e) {
        e.preventDefault();
        var btn = form.querySelector('.product-card__add-btn');
        var formData = new FormData(form);
        btn.textContent = 'ADDING...';
        btn.disabled = true;

        fetch('/cart/add.js', {
          method: 'POST',
          body: formData
        })
        .then(function(res) { return res.json(); })
        .then(function() {
          btn.textContent = 'ADDED!';
          setTimeout(function() {
            btn.textContent = 'ADD TO CART';
            btn.disabled = false;
          }, 1500);
        })
        .catch(function() {
          btn.textContent = 'ADD TO CART';
          btn.disabled = false;
        });
      });
    });
  }
})();

/* ============================================
   PRODUCT PAGE
   ============================================ */
(function() {
  'use strict';

  function initProductGallery() {
    var mainImage = document.getElementById('product-main-image');
    var zoomContainer = document.getElementById('product-zoom-container');
    var thumbs = document.querySelectorAll('.product-gallery__thumb');
    var prevBtn = document.querySelector('[data-gallery-prev]');
    var nextBtn = document.querySelector('[data-gallery-next]');
    if (!mainImage || !thumbs.length) return;

    var currentIndex = 0;
    var images = [];
    thumbs.forEach(function(t) { images.push(t.dataset.imageUrl); });

    function showImage(index) {
      currentIndex = (index + images.length) % images.length;
      mainImage.src = images[currentIndex];
      thumbs.forEach(function(t) { t.classList.remove('is-active'); });
      thumbs[currentIndex].classList.add('is-active');
      thumbs[currentIndex].scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    }

    thumbs.forEach(function(thumb, i) {
      thumb.addEventListener('click', function() { showImage(i); });
    });

    if (prevBtn) prevBtn.addEventListener('click', function() { showImage(currentIndex - 1); });
    if (nextBtn) nextBtn.addEventListener('click', function() { showImage(currentIndex + 1); });

    // Zoom on hover
    if (zoomContainer) {
      zoomContainer.addEventListener('mouseenter', function() {
        zoomContainer.classList.add('is-zoomed');
      });
      zoomContainer.addEventListener('mouseleave', function() {
        zoomContainer.classList.remove('is-zoomed');
        mainImage.style.transformOrigin = 'center center';
      });
      zoomContainer.addEventListener('mousemove', function(e) {
        if (!zoomContainer.classList.contains('is-zoomed')) return;
        var rect = zoomContainer.getBoundingClientRect();
        var x = ((e.clientX - rect.left) / rect.width) * 100;
        var y = ((e.clientY - rect.top) / rect.height) * 100;
        mainImage.style.transformOrigin = x + '% ' + y + '%';
      });
      zoomContainer.addEventListener('click', function() {
        zoomContainer.classList.toggle('is-zoomed');
      });
    }
  }

  function initVariantSelector() {
    var productJson = document.getElementById('product-json');
    if (!productJson) return;
    var product = JSON.parse(productJson.textContent);
    var variantInput = document.getElementById('product-variant-id');
    var priceEl = document.getElementById('product-price');
    var addBtn = document.getElementById('product-add-btn');
    var optionBtns = document.querySelectorAll('[data-option-value]');
    var selectedOptions = {};

    product.options.forEach(function(opt, i) {
      selectedOptions[i + 1] = product.variants[0]['option' + (i + 1)];
    });

    optionBtns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var position = parseInt(btn.dataset.optionPosition);
        var value = btn.dataset.optionValue;
        selectedOptions[position] = value;

        // Update active states
        btn.parentElement.querySelectorAll('[data-option-value]').forEach(function(b) {
          b.classList.remove('is-active');
        });
        btn.classList.add('is-active');

        // Update label
        var label = document.querySelector('[data-option-label="' + product.options[position - 1] + '"]');
        if (label) label.textContent = value;

        // Find matching variant
        var variant = product.variants.find(function(v) {
          return Object.keys(selectedOptions).every(function(pos) {
            return v['option' + pos] === selectedOptions[pos];
          });
        });

        if (variant) {
          variantInput.value = variant.id;
          updatePrice(variant);
          updateButton(variant);
          updateURL(variant);
        }
      });
    });

    function updatePrice(variant) {
      if (!priceEl) return;
      var html = '';
      if (variant.compare_at_price && variant.compare_at_price > variant.price) {
        html = '<span class="product-info__price-sale">' + formatMoney(variant.price) + '</span>';
        html += '<span class="product-info__price-compare">' + formatMoney(variant.compare_at_price) + '</span>';
        html += '<span class="product-info__price-badge">SAVE ' + formatMoney(variant.compare_at_price - variant.price) + '</span>';
      } else {
        html = '<span class="product-info__price-regular">' + formatMoney(variant.price) + '</span>';
      }
      priceEl.innerHTML = html;
    }

    function updateButton(variant) {
      if (!addBtn) return;
      if (variant.available) {
        addBtn.disabled = false;
        addBtn.textContent = 'ADD TO CART';
      } else {
        addBtn.disabled = true;
        addBtn.textContent = 'SOLD OUT';
      }
    }

    function updateURL(variant) {
      if (history.replaceState) {
        var url = window.location.pathname + '?variant=' + variant.id;
        history.replaceState({}, '', url);
      }
    }

    function formatMoney(cents) {
      return '$' + (cents / 100).toFixed(2);
    }
  }

  function initQuantitySelector() {
    var minusBtn = document.querySelector('.product-form__qty-btn[data-qty-minus]');
    var plusBtn = document.querySelector('.product-form__qty-btn[data-qty-plus]');
    var input = document.querySelector('.product-form__qty-input');
    if (!minusBtn || !plusBtn || !input) return;

    minusBtn.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      if (val > 1) input.value = val - 1;
    });
    plusBtn.addEventListener('click', function() {
      var val = parseInt(input.value) || 1;
      input.value = val + 1;
    });
  }

  function initProductTabs() {
    var btns = document.querySelectorAll('.product-tabs__btn');
    var panels = document.querySelectorAll('.product-tabs__panel');
    if (!btns.length) return;

    btns.forEach(function(btn) {
      btn.addEventListener('click', function() {
        var tab = btn.dataset.tab;
        btns.forEach(function(b) { b.classList.remove('is-active'); });
        panels.forEach(function(p) { p.classList.remove('is-active'); });
        btn.classList.add('is-active');
        var panel = document.querySelector('[data-panel="' + tab + '"]');
        if (panel) panel.classList.add('is-active');
      });
    });
  }

  function initProductRecommendations() {
    var container = document.querySelector('.product-recommendations[data-url]');
    if (!container) return;
    var url = container.dataset.url;
    fetch(url)
      .then(function(r) { return r.text(); })
      .then(function(html) {
        var parser = new DOMParser();
        var doc = parser.parseFromString(html, 'text/html');
        var recs = doc.querySelector('.product-recommendations');
        if (recs && recs.querySelector('.product-recommendations__item')) {
          container.innerHTML = recs.innerHTML;
        }
      })
      .catch(function() {});
  }

  document.addEventListener('DOMContentLoaded', function() {
    initProductGallery();
    initVariantSelector();
    initQuantitySelector();
    initProductTabs();
    initProductRecommendations();
  });
})();

/* --- Find Your Routine Quiz --- */
(function() {
  'use strict';

  function initQuiz() {
    var container = document.querySelector('.quiz-container');
    if (!container) return;

    var steps = container.querySelectorAll('.quiz-step');
    var totalSteps = steps.length;
    var currentStep = 1;
    var answers = {};

    var progressFill = document.getElementById('quizProgressFill');
    var progressText = document.getElementById('quizProgressText');
    var btnBack = document.getElementById('quizBack');
    var btnNext = document.getElementById('quizNext');
    var resultsEl = document.getElementById('quizResults');
    var stepsContainer = document.getElementById('quizSteps');
    var navEl = container.querySelector('.quiz-nav');
    var progressEl = container.querySelector('.quiz-progress');

    function updateProgress() {
      var pct = (currentStep / totalSteps) * 100;
      progressFill.style.width = pct + '%';
      progressText.textContent = 'Question ' + currentStep + ' / ' + totalSteps;
    }

    function showStep(step) {
      steps.forEach(function(s) { s.classList.remove('is-active'); });
      var target = container.querySelector('[data-step="' + step + '"]');
      if (target) target.classList.add('is-active');
      btnBack.disabled = (step === 1);
      var stepOptions = target ? target.querySelectorAll('.quiz-option') : [];
      var hasSelection = false;
      stepOptions.forEach(function(opt) {
        if (opt.classList.contains('is-selected')) hasSelection = true;
      });
      btnNext.disabled = !hasSelection;
      updateProgress();
    }

    container.addEventListener('click', function(e) {
      var option = e.target.closest('.quiz-option');
      if (!option) return;

      var step = option.closest('.quiz-step');
      var siblings = step.querySelectorAll('.quiz-option');
      siblings.forEach(function(s) {
        s.classList.remove('is-selected');
        s.setAttribute('aria-selected', 'false');
      });
      option.classList.add('is-selected');
      option.setAttribute('aria-selected', 'true');

      var question = option.getAttribute('data-question');
      var value = option.getAttribute('data-value');
      answers[question] = value;

      btnNext.disabled = false;
    });

    btnNext.addEventListener('click', function() {
      if (currentStep < totalSteps) {
        currentStep++;
        showStep(currentStep);
      } else {
        showResults();
      }
    });

    btnBack.addEventListener('click', function() {
      if (currentStep > 1) {
        currentStep--;
        showStep(currentStep);
      }
    });

    function showResults() {
      stepsContainer.style.display = 'none';
      navEl.style.display = 'none';
      progressEl.style.display = 'none';
      resultsEl.style.display = 'block';
    }

    showStep(1);
  }

  document.addEventListener('DOMContentLoaded', initQuiz);
})();

/* ============================================
   CART PAGE & DRAWER
   ============================================ */
(function() {
  'use strict';

  var FREE_SHIPPING_THRESHOLD = 8000; // cents

  function formatMoney(cents) {
    return '$' + (cents / 100).toFixed(2);
  }

  // Cart Drawer open/close
  function initCartDrawerToggle() {
    var drawer = document.getElementById('cart-drawer');
    var overlay = document.querySelector('[data-cart-drawer-overlay]');
    var closeBtn = document.querySelector('[data-cart-drawer-close]');
    var cartToggle = document.querySelector('[data-cart-toggle]');
    if (!drawer) return;

    function openDrawer() {
      drawer.classList.add('is-open');
      drawer.setAttribute('aria-hidden', 'false');
      if (overlay) overlay.classList.add('is-visible');
      document.body.style.overflow = 'hidden';
    }

    function closeDrawer() {
      drawer.classList.remove('is-open');
      drawer.setAttribute('aria-hidden', 'true');
      if (overlay) overlay.classList.remove('is-visible');
      document.body.style.overflow = '';
    }

    if (cartToggle) cartToggle.addEventListener('click', function(e) { e.preventDefault(); openDrawer(); });
    if (closeBtn) closeBtn.addEventListener('click', closeDrawer);
    if (overlay) overlay.addEventListener('click', closeDrawer);

    document.addEventListener('keydown', function(e) {
      if (e.key === 'Escape' && drawer.classList.contains('is-open')) closeDrawer();
    });

    window._cartDrawer = { open: openDrawer, close: closeDrawer };
  }

  // AJAX cart operations
  function fetchCart() {
    return fetch('/cart.js').then(function(r) { return r.json(); });
  }

  function updateCartQuantity(line, quantity) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: quantity })
    }).then(function(r) { return r.json(); });
  }

  function removeCartItem(line) {
    return updateCartQuantity(line, 0);
  }

  function updateShippingBar(totalPrice) {
    var bars = document.querySelectorAll('[data-drawer-shipping], .cart-shipping-bar');
    var remaining = FREE_SHIPPING_THRESHOLD - totalPrice;
    bars.forEach(function(bar) {
      if (!bar) return;
      var progress = Math.min((totalPrice / FREE_SHIPPING_THRESHOLD) * 100, 100);
      if (remaining <= 0) {
        bar.innerHTML = '<p class="cart-shipping-bar__text cart-shipping-bar__text--success">You\'ve unlocked <strong>FREE shipping!</strong></p><div class="cart-shipping-bar__track"><div class="cart-shipping-bar__fill" style="width:100%"></div></div>';
      } else {
        bar.innerHTML = '<p class="cart-shipping-bar__text">Spend <strong>' + formatMoney(remaining) + '</strong> more for <strong>FREE shipping!</strong></p><div class="cart-shipping-bar__track"><div class="cart-shipping-bar__fill" style="width:' + progress + '%"></div></div>';
      }
    });
  }

  function updateCartUI(cart) {
    // Update count badges
    var countEls = document.querySelectorAll('[data-drawer-count], [data-cart-count]');
    countEls.forEach(function(el) { el.textContent = '• ' + cart.item_count; });

    // Update subtotals
    var subtotalEls = document.querySelectorAll('[data-cart-subtotal], [data-drawer-subtotal], [data-cart-total]');
    subtotalEls.forEach(function(el) { el.textContent = formatMoney(cart.total_price); });

    // Update shipping bar
    updateShippingBar(cart.total_price);

    // Update page title count
    var pageTitle = document.querySelector('.cart-page__title');
    if (pageTitle) pageTitle.textContent = 'Your Cart (' + cart.item_count + ')';
  }

  function refreshCartContent(cart) {
    updateCartUI(cart);

    // If cart is empty, reload to show empty state
    if (cart.item_count === 0) {
      window.location.reload();
      return;
    }

    // Update line item totals
    cart.items.forEach(function(item, index) {
      var line = index + 1;
      var pageItem = document.querySelector('.cart-page .cart-item[data-line="' + line + '"]');
      if (pageItem) {
        var totalEl = pageItem.querySelector('[data-item-total]');
        if (totalEl) totalEl.textContent = formatMoney(item.final_line_price);
        var qtyInput = pageItem.querySelector('[data-qty-input]');
        if (qtyInput) qtyInput.value = item.quantity;
      }
      var drawerItem = document.querySelector('.cart-drawer-item[data-line="' + line + '"]');
      if (drawerItem) {
        var dTotalEl = drawerItem.querySelector('[data-item-total]');
        if (dTotalEl) dTotalEl.textContent = formatMoney(item.final_line_price);
        var dQtyInput = drawerItem.querySelector('[data-qty-input]');
        if (dQtyInput) dQtyInput.value = item.quantity;
      }
    });
  }

  // Quantity change handlers
  function initQuantityControls() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-qty-change]');
      if (!btn) return;

      var container = btn.closest('[data-cart-item], [data-drawer-item]');
      if (!container) return;

      var input = container.querySelector('[data-qty-input]');
      var line = parseInt(container.dataset.line);
      var change = parseInt(btn.dataset.qtyChange);
      var newQty = Math.max(1, parseInt(input.value) + change);

      input.value = newQty;
      container.style.opacity = '0.5';

      updateCartQuantity(line, newQty).then(function(cart) {
        container.style.opacity = '1';
        refreshCartContent(cart);
      }).catch(function() {
        container.style.opacity = '1';
      });
    });

    // Direct input change
    document.addEventListener('change', function(e) {
      var input = e.target.closest('[data-qty-input]');
      if (!input) return;

      var container = input.closest('[data-cart-item], [data-drawer-item]');
      if (!container) return;

      var line = parseInt(container.dataset.line);
      var newQty = Math.max(1, parseInt(input.value) || 1);
      input.value = newQty;
      container.style.opacity = '0.5';

      updateCartQuantity(line, newQty).then(function(cart) {
        container.style.opacity = '1';
        refreshCartContent(cart);
      }).catch(function() {
        container.style.opacity = '1';
      });
    });
  }

  // Remove item handlers
  function initRemoveButtons() {
    document.addEventListener('click', function(e) {
      var btn = e.target.closest('[data-cart-remove]');
      if (!btn) return;

      var container = btn.closest('[data-cart-item], [data-drawer-item]');
      if (!container) return;

      var line = parseInt(container.dataset.line);
      container.style.opacity = '0.5';

      removeCartItem(line).then(function(cart) {
        container.remove();
        refreshCartContent(cart);
      }).catch(function() {
        container.style.opacity = '1';
      });
    });
  }

  // Add to cart with drawer open
  function initAddToCartAjax() {
    document.addEventListener('submit', function(e) {
      var form = e.target.closest('form[action="/cart/add"]');
      if (!form) return;
      if (form.hasAttribute('data-add-to-cart-form')) return; // handled elsewhere

      e.preventDefault();
      var btn = form.querySelector('[type="submit"]');
      var originalText = btn ? btn.textContent : '';
      if (btn) { btn.textContent = 'Adding...'; btn.disabled = true; }

      fetch('/cart/add.js', {
        method: 'POST',
        body: new FormData(form)
      })
      .then(function(r) { return r.json(); })
      .then(function() {
        if (btn) { btn.textContent = 'Added!'; }
        if (window._cartDrawer) window._cartDrawer.open();
        return fetchCart();
      })
      .then(function(cart) {
        updateCartUI(cart);
        setTimeout(function() {
          if (btn) { btn.textContent = originalText; btn.disabled = false; }
        }, 1500);
      })
      .catch(function() {
        if (btn) { btn.textContent = originalText; btn.disabled = false; }
      });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initCartDrawerToggle();
    initQuantityControls();
    initRemoveButtons();
    initAddToCartAjax();
  });
})();

/* ============================================
   HOMEPAGE — Hero Slider & Carousels
   ============================================ */
(function() {
  'use strict';

  function initHeroSliderV2() {
    var slider = document.querySelector('[data-hero-slider]');
    if (!slider) return;
    var slides = slider.querySelectorAll('.hero-slider__slide');
    var prevBtn = slider.querySelector('[data-hero-prev]');
    var nextBtn = slider.querySelector('[data-hero-next]');
    if (slides.length < 2) return;

    // Ensure first slide is active on init
    slides.forEach(function(s) { s.classList.remove('is-active'); });
    slides[0].classList.add('is-active');

    var current = 0;
    var interval;
    var speed = parseInt(slider.dataset.speed) || 6000;
    var isTransitioning = false;

    function goTo(index) {
      if (isTransitioning) return;
      isTransitioning = true;
      var prev = current;
      current = (index + slides.length) % slides.length;

      slides[prev].classList.remove('is-active');
      slides[current].classList.add('is-active');

      slides.forEach(function(slide, i) {
        var video = slide.querySelector('video');
        if (video) {
          if (i === current) { video.currentTime = 0; video.play(); } else { video.pause(); }
        }
      });

      setTimeout(function() { isTransitioning = false; }, 500);
    }

    function startAuto() {
      interval = setInterval(function() { goTo(current + 1); }, speed);
    }
    function stopAuto() { clearInterval(interval); }

    if (prevBtn) prevBtn.addEventListener('click', function() { stopAuto(); goTo(current - 1); startAuto(); });
    if (nextBtn) nextBtn.addEventListener('click', function() { stopAuto(); goTo(current + 1); startAuto(); });

    var touchStartX = 0;
    slider.addEventListener('touchstart', function(e) { touchStartX = e.touches[0].clientX; }, { passive: true });
    slider.addEventListener('touchend', function(e) {
      var diff = touchStartX - e.changedTouches[0].clientX;
      if (Math.abs(diff) > 50) {
        stopAuto();
        if (diff > 0) { goTo(current + 1); } else { goTo(current - 1); }
        startAuto();
      }
    }, { passive: true });

    startAuto();
  }

  function initAllCarousels() {
    document.querySelectorAll('[data-carousel]').forEach(function(carousel) {
      var track = carousel.querySelector('.product-carousel__track');
      var prevBtn = carousel.querySelector('[data-carousel-prev]');
      var nextBtn = carousel.querySelector('[data-carousel-next]');
      if (!track) return;

      var scrollAmount = track.firstElementChild ? track.firstElementChild.offsetWidth + 20 : 320;

      function updateArrows() {
        if (prevBtn) prevBtn.style.opacity = track.scrollLeft <= 10 ? '0.3' : '1';
        if (nextBtn) nextBtn.style.opacity = track.scrollLeft >= track.scrollWidth - track.clientWidth - 10 ? '0.3' : '1';
      }

      if (prevBtn) prevBtn.addEventListener('click', function() {
        track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
      });
      if (nextBtn) nextBtn.addEventListener('click', function() {
        track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
      });

      track.addEventListener('scroll', updateArrows, { passive: true });
      updateArrows();
    });
  }

  function initReviewsCarousel() {
    var carousel = document.querySelector('[data-reviews-carousel]');
    if (!carousel) return;
    var track = carousel.querySelector('.reviews-section__track');
    var prevBtn = carousel.querySelector('[data-reviews-prev]');
    var nextBtn = carousel.querySelector('[data-reviews-next]');
    if (!track) return;

    var scrollAmount = track.firstElementChild ? track.firstElementChild.offsetWidth + 20 : 300;

    if (prevBtn) prevBtn.addEventListener('click', function() {
      track.scrollBy({ left: -scrollAmount, behavior: 'smooth' });
    });
    if (nextBtn) nextBtn.addEventListener('click', function() {
      track.scrollBy({ left: scrollAmount, behavior: 'smooth' });
    });
  }

  document.addEventListener('DOMContentLoaded', function() {
    initHeroSliderV2();
    initAllCarousels();
    initReviewsCarousel();
  });
})();
